// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"982fb03a","314":"27138de3","401":"4df2c526","480":"9fa3ed02","534":"982fb03a","615":"982fb03a"}[chunkId] + ".chunk.css";
};